






















































































import { Component, Vue } from 'vue-property-decorator';
import API from '@/Api';
import { APP_DRAWER_TOGGLED } from '@/mutation-types';
import { ICodeTable , ISclModel, ISnackBar } from '@/models/Common';

@Component
export default class Scl extends Vue {
  public dataTable: ISclModel[] = [];
  public items: any = ['Thunder', 'Phanther', 'Blasters', 'Lions'];
  public value: any = [];
  public drinks: any = ['No', 'Yes'];
  public type: any = ['Batsmen', 'Bowler', 'All-Rounder', 'Oppuku Sappan'];
  public drinkType: any = ['Hot', 'Soft', 'Cool Drink'];
  public scl: any = ['No', 'Yes'];
  public radioGroup: any = '1';
  public radioGroupDrink: any = '1';
  public radioGroupDrinkType: any = '1';
  public radioGroupSclTye: any = '0';
  public num: number = 0;
  public numTeam: number = 0;
  public sclTeam: ICodeTable[] = [];
  public sclTeamv2: ICodeTable[] = [];
  public hasCodeTableLoaded: boolean = false;
  public sclDetail: any = [];
  public drinker: boolean = false;
  public src: any = '@/assets/endcard.jpeg';
  public search: string = '';

   public headers: any = [
    {
      text: 'Name',
      align: 'left',
      sortable: false,
      value: 'name',
    },
    {
      text: 'Employee Id',
      align: 'left',
      sortable: false,
      value: 'employeeId',
    },
    {
      text: 'About',
      align: 'left',
      sortable: false,
      value: 'about',
    }];

  public created() {
    API.Instance.get('/api/code-table?id=14&seletedId=').then((response) => {
      this.sclTeam = response.data;
      this.hasCodeTableLoaded = true;
      //this.anyTeam();
      //this.loadScl();
      this.loadData();
    });
  }
  public anyTeam() {
    API.Instance.get('/api/code-table?id=22&seletedId=').then((response) => {
      this.sclTeamv2 = response.data;
      this.hasCodeTableLoaded = true;
    });
  }
  public mounted() {
    if (this.hasCodeTableLoaded) {
      //this.loadScl();
      this.loadData();
    }
  }
  public loadData() {
    API.Instance.get('/api/goalsettings/getempcarrom').then((respone) => {
      this.dataTable = respone.data;
      this.sclDetail = respone.data;

      this.sclDetail.empName=respone.data[0].empName;
      this.sclDetail.empid=respone.data[0].empid;
      this.sclDetail.issubmitted=respone.data[0].issubmitted;

    });
  }
  public loadScl() {
    API.Instance.get('/api/scl-data').then((respone) => {
      this.sclDetail = respone.data;
      this.radioGroupDrinkType = this.sclDetail.drinks;
      this.radioGroup = this.sclDetail.type;
      this.sclDetail.empName=this.sclDetail.name;
      this.sclDetail.empid=this.sclDetail.employeeId;
      
    });
  }
  public submit() {
    API.Instance.post('api/goalsettings/addempcarrom', {
      empName: this.sclDetail.empName,
      empid: this.sclDetail.empid,
      comments: this.sclDetail.comments,
      submitted: this.sclDetail.issubmitted,
    }).then((respone) => {
      this.sclDetail = respone.data;
      //this.loadScl();
      this.loadData();
    });
  }
  get getscl() {
    return '/scl-list';
  }
}
